import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GcTextComponent, IpoTranslatePipe } from '@ip-only/front-end-library';
import { TextInputData } from '../../report-input-entities';
import { OptionsButtonComponent } from '../options-button/options-button.component';
import { TextInputComponent } from '../text-input/text-input.component';

@Component({
  selector: 'app-not-applicable',
  imports: [
    TextInputComponent,
    GcTextComponent,
    IpoTranslatePipe,
    OptionsButtonComponent,
  ],
  templateUrl: './not-applicable.component.html',
  styleUrl: './not-applicable.component.scss',
})
export class NotApplicableComponent implements OnInit {
  @Input() comment: string | null;
  @Input() sectionDescription: string;
  @Input() id: string;
  @Input() isEditMode: boolean;
  @Output() cancel = new EventEmitter();
  @Output() markAsNA = new EventEmitter<string>();

  textInputData: TextInputData;

  ngOnInit(): void {
    this.setTextInputData();
  }

  setTextInputData() {
    this.textInputData = this.createTextInputData(this.comment ?? '');
  }

  handleCancel() {
    this.cancel.emit();
  }

  handleMarkAsNA(input: string) {
    this.comment = input;
    this.markAsNA.emit(input);
  }

  createTextInputData = (comment: string): TextInputData => ({
    id: 'editSelfInspection',
    label: 'reportInput.text.label',
    isDone: false,
    placeHolder: 'reportInput.text.placeholder',
    isTextArea: true,
    savedValue: comment,
  });
}
